import { HttpClient } from '../interceptor';

export class CourseCardsManagementApi{
    // 获取课程次卡列表
    static getCourseCardsList = () => {
        return new Promise(resolve => {
            HttpClient.post('/api/courseCardController/queryCourseCardToB', {}).then(res => {
                if(res.data.status === 200){
                    resolve(res.data.content);
                }
            }).catch(err => console.log(err));
        })
    }

    // 新增课程次卡
    static insertCourseCard = (param) => {
        return new Promise(resolve => {
            HttpClient.post('/api/courseCardController/addCourseCard', param).then(res => {
                resolve(res);
            }).catch(err => console.log(err));
        })
    }

    // 编辑课程卡
    static updateCourseCard = (param) => {
        return new Promise(resolve => {
            HttpClient.post('/api/courseCardController/updateCourseCardToB', param).then(res => {
                resolve(res);
            }).catch(err => console.log(err));
        })
    }
}